<template>
  <div>Reviews form</div>
</template>

<script>
export default {
  name: "reviews-form",
  selector: ".reviews-form",
}
</script>

<style scoped>

</style>